import { render, staticRenderFns } from "./CityTributation.vue?vue&type=template&id=221e1f9e&"
import script from "./CityTributation.vue?vue&type=script&lang=js&"
export * from "./CityTributation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports